import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Modal } from "ngx-modal";
import { PaginationInstance } from 'ngx-pagination';
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { RowStatus } from "../../../common/enums/row-status.enum";
import { AuthorizationExtensionPipe } from "../../../common/pipes/authorization-extension.pipe";
import { MessageService } from "../../../shared/services/message.service";
import { Utils } from "../../../shared/Utils/utils";
import { OperatingCountryEnums } from "../../enums/countries.enums";
import { NotificationType } from "../../enums/notification-types.enum";
import { DepartmentModel } from "../../interface/department-model";
import { DepartmentInfoTab } from "../../models/department-info-tab-model";
import { CustomerService } from "../../services/customer.service";
import { DepartmentService } from "../../services/department.service";
import { Permission } from "./../../../common/enums/permission.enum";
import { CommonService } from "./../../../shared/services/common.service";


@Component({
    selector: "customer-department-search",
    templateUrl: "../../templates/template1/views/department/department-search.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/department.less"],
    providers: [AuthorizationExtensionPipe]
})
export class DepartmentsSearchComponent implements OnInit {

    DepartmentPermissions: any[] = [Permission.MANAGE_DEPARTMENT_VIEW,];
    permission:any = Permission;
    pageNumber: number = this._localStorageService.get('departmentPageNumber')? this._localStorageService.get('departmentPageNumber') : 1;
    pageSize: number = 10;
    pageCount: number = 0;
    sortColumn: string;
    isDesc: boolean = false;
    isCountriesLoading = false;
    viewDepartmentPermission:boolean;
    operatingCountries:any[];
   @ViewChild('myDepartmentModal') modal: Modal;
    name: string = this._localStorageService.get('departmentSearchKey')? this._localStorageService.get('departmentSearchKey') : "";
    operatingCountryId: string = this._localStorageService.get('departmentOperatingCountry')? this._localStorageService.get('departmentOperatingCountry') : "";
    departments: DepartmentModel[];
    rowStatus:any=RowStatus;
    public departmentModalPopup: any = {
      isTicketsAssigned:false,
      departmentId:  0,
      isEnable: false,
      rowStatus:0,
      message:'',
      title:''
   };
    public paginationInstance: PaginationInstance = {
    id: 'departmentSearch-pagination',
    itemsPerPage: 10,
    currentPage: 1
     };


    constructor(private router: Router,  private _customerservice: CustomerService,
    private _translatePipe: TranslateService,
    private _commonService: CommonService,
    private _departmentService: DepartmentService,
    private messageService: MessageService,
    private _localStorageService: LocalStorageService) {
    }

    ngOnInit() {
        
        this.setFocusToTextBox();
        this.getOperatingCountries();
        this.searchDepartments();

        this.viewDepartmentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.DepartmentPermissions[0] + "]"),AccessLevel.Account); 
    }
    setFocusToTextBox(){
        
        setTimeout(function(){ 
            const autoFocusElement = document.getElementById("autofocus-element");
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
         }, 200);
    }
   nameKeyPress(event: any) {
        this._localStorageService.set('departmentSearchKey',this.name);
        this._localStorageService.set('departmentOperatingCountry',this.operatingCountryId);
        this._localStorageService.set('departmentPageNumber',this.pageNumber);
       let inputChar = String.fromCharCode(event.charCode);
       let allowedChars:string[]=  [':', '_', '-'];
        if(!Utils.validateSpecialCharacterRule(inputChar,allowedChars)){
              event.preventDefault();
        }   
   }
    searchDepartments() {
        if(this.name){
            this._localStorageService.set('departmentSearchKey',this.name);
        }
            
        if(this.operatingCountryId){
            this._localStorageService.set('departmentOperatingCountry',this.operatingCountryId);
        }           
        this._localStorageService.set('departmentPageNumber',this.pageNumber);
        window.document.getElementById("search-button").classList.add('button-active');
        setTimeout(() => {
            window.document.getElementById("search-button").classList.remove('button-active');
          }, 1000);
        this._departmentService.getDepartments(this.pageNumber, this.pageSize, this.sortColumn, this.isDesc, this.name, +(this.operatingCountryId)).subscribe(response => {
            if (response) {
                this.pageCount = response.totalCount;
                this.departments = response.content;
            }
            else{
                this.pageCount = 0;
                this.departments = [];
            }
        });
    }
    onSearch() {        
        this.pageNumber = 1;
        this.searchDepartments();
    }
    clearFields()
    {
        this.setFocusToTextBox();
        this.name='';
        this.operatingCountryId="";
        this.pageNumber=1;
        this.isDesc = false;
        this._localStorageService.remove('departmentSearchKey');
        this._localStorageService.remove('departmentOperatingCountry');
        this._localStorageService.remove('departmentPageNumber');
        this.searchDepartments();
    }

    departmentUsers(department: any) {
        if (department) {
            this.router.navigate(['/customerservice/department', department.id, 'users'], { fragment: (department.name+"_"+department.operatingCountryId) });
        }
    }

    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.searchDepartments();
    }

    sort(sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sortColumn = sortColumn;
        this.searchDepartments();
    }

    viewDepartment(id: number): void {        
        this.router.navigate(['/customerservice/department' , id,'view']);
    }

    editDepartment(id: number): void {        
        this.router.navigate(['/customerservice/departments' , id]);
    }

    getOperatingCountries(){        
    this.isCountriesLoading = true;    
    this._customerservice.getAllBusinessEntities().subscribe((response:any) => {
          if (response) {  
              this.isCountriesLoading = false; 
              this.operatingCountries = response;
              
              let countryInfo = this.operatingCountries.find((country:any) =>  country.id === OperatingCountryEnums.USA);
              if(countryInfo){
                  this.operatingCountries.splice( this.operatingCountries.indexOf(countryInfo), 1 );
                  this.operatingCountries.splice(0, 0, countryInfo);
              }
          }
      },error => {
        this.isCountriesLoading = false; 
      });    
  
   } 

    modelPopupDeleteOpen(departmentId: any, status: Number) {
       
    this.departmentModalPopup.isTicketsAssigned = false;
    this.departmentModalPopup.departmentId = departmentId;
    this.departmentModalPopup.rowStatus=status
    if(status===RowStatus.Active){
        this.departmentModalPopup.message='Do you want to Deactivate department ?';
        this.departmentModalPopup.title='Deactivate Department';
    }
    else if(status===RowStatus.Inactive){
           this.departmentModalPopup.message='Do you want to Activate department ?';
           this.departmentModalPopup.title='Activate Department';
    }
     this._departmentService.getDepartmentTicketsStatus(departmentId).subscribe(response => {
            if (response) {
                this.departmentModalPopup.isTicketsAssigned = response;
            }
            else{
                 this.departmentModalPopup.isTicketsAssigned = false;
            }
            if(this.departmentModalPopup.isTicketsAssigned && this.departmentModalPopup.rowStatus===RowStatus.Active){
                  this.departmentModalPopup.message='Currently department has open tickets.Cannot be Deactivated';
            }
            else{
              this.departmentModalPopup.message='Do you want to continue ?';
            }
             this.modal.open();
        }); 
  }

  deactivateDepartment(id: any, status: Number){
     
    let active = status===RowStatus.Active ? false : true;
    let message :String = (active ?"activated":"deactivated");
    this._departmentService.deactivateDepartment(id,active).subscribe((response:any) => {
        if(response) {
            let notification: any = this._translatePipe.get("Department is "+message+ " successfully");
            this._commonService.createNotification("",notification.value, NotificationType.SUCCESS);
        }
        else{
            let notification: any = this._translatePipe.get("Department activated/deactivated failed");
            this._commonService.createNotification("",notification.value, NotificationType.ERROR);
        }
        this.modal.close();
        this.searchDepartments();
     });
  }
    /**
     * View deaprtment
     */
    goToDepartmentView(departmentId: number, departmentName: string,operatingCountryId:number ) {
        let deptInfo = new DepartmentInfoTab();       
        deptInfo.departmentID = departmentId;
        deptInfo.title = departmentName;
        deptInfo.removable = true;
        deptInfo.disabled = false;
        deptInfo.active = true;
        deptInfo.operatingCountryId = operatingCountryId;
        this.messageService.setDepartmentTabContent(deptInfo);
    } 
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-search.component.ts